import React from 'react';
import { ElementLoader } from 'ui';
import { deepEquals } from 'app/infrastructure/js';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { SerializePayload } from 'app/area/search-filters/types';
import { OperationsSearchModel, ListRendererProps } from '../types-store';
import { serialize } from '../serialize';
import { ListResults } from './list-results';
import styles from './list-renderer.scss';

export const ListRenderer: React.FC<ListRendererProps> = ({
  listState, translation, loadList, updateOperations
}) => {

  const { updating, requestedSearchModel, listItems, numberOfResults } = listState;

  const updateSearchModel = (payload: SerializePayload) => {
    onLoadData(serialize(payload));
  };

  const onLoadData = (searchModel: OperationsSearchModel) => {

    if (!deepEquals(searchModel, requestedSearchModel)) {
      loadList(searchModel);
    }
  };

  return <>
    <SearchFilters
      hideDrawer={true}
      hideSearch={true}
      hideSearchLayout={true}
      topToolbar={undefined}
      rightToolbar={undefined}
      queryFilters={undefined}
      predefinedFilters={undefined}
      customFilters={undefined}
      defaultFilterValues={undefined}
      filtersConfig={{ area: 'operations' }}
      updateSearchModel={updateSearchModel}>
      {!!listItems && <div className="row">
        <div className="col-12">
          <div className={`${styles.alertInfo} mt-4 mb-2`}>
            <p className="mb-0">
              {translation.operations_auto_save_info}
            </p>
          </div>
          <div id="operations_number_of_results"
            className={styles.noOfResults}>
            {numberOfResults === 0
              ? translation.search_no_experience_transfer
              : `${numberOfResults} ${translation.search_hits}`}
          </div>
        </div>
      </div>}
      {listItems && listItems.length > 0
        ? <ListResults
          listItems={listItems}
          updating={updating}
          updateOperations={updateOperations}
          translation={translation} />
        : null}
      {listState.fetching ? <ElementLoader /> : null}
    </SearchFilters>
  </>;
};
